import { Pencil, Trash2, Info } from 'lucide-react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../hooks/useStore';
import type { IOvertimeResult } from '../../../../models/overtime/OvertimeModel';
import styles from '../OvertimeManagement.module.css';

export type OvertimeManagementActionCellProps = {
  row: IOvertimeResult;
};

const OvertimeManagementActionCell = ({ row }: OvertimeManagementActionCellProps) => {
  const { popupStore, overtimeStore } = useStore();

  const handleEdit = (e: React.MouseEvent) => {
    e.stopPropagation();
    overtimeStore.setSelectedOvertime(row);
    popupStore.setIsEditOvertimeOpen(true);
  };

  const handleDelete = (e: React.MouseEvent) => {
    e.stopPropagation();
    if (row.id) {
      overtimeStore.setOvertimeToDelete(row);
      popupStore.setIsDeleteOvertimeConfirmationOpen(true);
    }
  };

  const handleShowRejectionReason = (e: React.MouseEvent) => {
    e.stopPropagation();
    overtimeStore.setSelectedOvertime(row);
    popupStore.setIsRejectionReasonOpen(true);
  };

  return (
    <div className={styles.actionCell}>
      <button onClick={handleEdit} className={styles.editButton} title="Düzenle">
        <Pencil size={16} strokeWidth={2} />
      </button>
      <button onClick={handleDelete} className={styles.deleteButton} title="Sil">
        <Trash2 size={16} strokeWidth={2} />
      </button>
      {row.status === 'Rejected' && row.rejectionReason ? (
        <button
          onClick={handleShowRejectionReason}
          className={styles.infoButton}
          title="Red Sebebini Görüntüle"
        >
          <Info size={16} strokeWidth={2} />
        </button>
      ) : null}
    </div>
  );
};

export default observer(OvertimeManagementActionCell);
